import { Action, State, types } from '.';

const initialState: State = {
    submitting: false,
    submitted: false,
    termsAgreed: false
};

export default function (state: State = initialState, action: Action): State {
    switch (action.type) {
        case types.ACTION_SERVER_DATA_AGREE_TERMS_REQUESTED:
            return {
                ...state,
                submitting: true,
                submitted: false
            };

        case types.ACTION_SERVER_DATA_AGREE_TERMS_FAILED:
            return {
                ...state,
                submitting: false,
                submitted: false
            };

        case types.SUBMIT_AGREE_TERMS_SUCCEED:
            return {
                ...state,
                submitting: false,
                submitted: true,
                termsAgreed: action.termsAgreed
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/entities/agreeTerms/reducer.ts